import { render } from "./SelectControl.vue?vue&type=template&id=70dabdb4"
import script from "./SelectControl.vue?vue&type=script&lang=js"
export * from "./SelectControl.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mior/Projects/laravel/nova/silver-surfer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"SelectControl.vue"]])

export default __exports__